import { render, staticRenderFns } from "./NumberOfSars.vue?vue&type=template&id=a96ae0be&"
import script from "./NumberOfSars.vue?vue&type=script&lang=js&"
export * from "./NumberOfSars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports